import React, { ReactNode, CSSProperties } from 'react'
import { Color, IServiceInfo, IStop } from '../../../../models'
import theme from '../../../../theme'
import StyledLi from './styles'
import { StopMarker } from '../../../../components'
import { Application } from '../../../../config'

interface IProps {
  stop: IStop
  serviceInfo: IServiceInfo
  onPress: (stop: IStop) => any
  destinationBusStops: IStop[]
  pickedServiceInfo: number | null
  pickedOriginBusStop?: IStop
  pickedDestinationBusStop?: IStop
  restrictedOrigins?: number[]
}

export const StopLine: React.FC<IProps> =
  ({ stop, serviceInfo, onPress, destinationBusStops, pickedServiceInfo, pickedOriginBusStop, pickedDestinationBusStop, restrictedOrigins }) => {
    const isDifferentService = !!(pickedServiceInfo && serviceInfo.id !== pickedServiceInfo)
    const { isAmb } = Application

    const isDisabled = (): boolean => {
      if (isDifferentService) return true
      if ((pickedOriginBusStop || pickedDestinationBusStop) && destinationBusStops.length === 0) return true

      const isSelectable = destinationBusStops.some(dbs => dbs.id === stop.id)
      const isOrigin =
        pickedOriginBusStop == null
          ? false
          : pickedOriginBusStop && pickedOriginBusStop.id === stop.id

      const checkIfIsRestricted = restrictedOrigins ? restrictedOrigins.includes(stop.id) : false;
      if (isOrigin) return false
      return pickedOriginBusStop ? destinationBusStops.length > 0 && !isSelectable : checkIfIsRestricted
    }

    const getMarkerColor = (): Color => {
      if (isDifferentService) return theme.colors.greyMedium

      const pickedOriginBusStopId = pickedOriginBusStop && pickedOriginBusStop.id
      const pickedDestinationBusStopId =
        pickedDestinationBusStop && pickedDestinationBusStop.id
      let iconColor = theme.colors.black

      switch (stop.id) {
        case pickedOriginBusStopId:
          iconColor = theme.colors.blueLight
          break
        case pickedDestinationBusStopId:
          iconColor = theme.colors.greenRadio
          break
      }

      if (isDisabled() && iconColor === theme.colors.black) return theme.colors.greyMedium

      return iconColor
    }

    const getTextStyle = (): CSSProperties => {
      if (isDifferentService) {
        return {
          fontSize: '18px',
          opacity: isDisabled() ? 0.5 : 1
        }
      }

      const pickedOriginBusStopId = pickedOriginBusStop && pickedOriginBusStop.id
      const pickedDestinationBusStopId =
        pickedDestinationBusStop && pickedDestinationBusStop.id

      switch (stop.id) {
        case pickedOriginBusStopId:
        case pickedDestinationBusStopId:
          return {
            fontSize: '18px',
            color: theme.colors.black
          }
        default:
          return {
            fontSize: '18px',
            opacity: isDisabled() ? 0.5 : 1
          }
      }
    }

    const codeStyle = (): CSSProperties => {
      const opacity = isDisabled() ? 0.5 : 1
      return {
        opacity,
        color: theme.colors.grey,
        margin: '0 4px'
      }
    }

    const stopCode = (): ReactNode => {
      const code = stop.code
      if (!code) return null
      return <span style={ codeStyle() }>({ code })</span>
    }

    return (
      <StyledLi
        onClick={ () => { !isDisabled() && onPress(stop) }}
      >
        <StopMarker color={ getMarkerColor() } />
        <div className="line-info">
          <p style={ getTextStyle() }>{ stop.name } { isAmb && stopCode }</p>
        </div>
      </StyledLi>
    )
}
